import PlausibleProvider from 'next-plausible';
import type { FC, ReactNode } from 'react';
import { SWRConfig } from 'swr';

import { ToastContainer } from '@/components/ui/toast';

type ProvidersProps = {
  children: ReactNode;
};

const Providers: FC<ProvidersProps> = ({ children }) => (
  <SWRConfig
    value={{
      refreshInterval: 60000,
      fetcher: (resource, init) =>
        fetch(resource, init).then((res) => res.json()),
    }}
  >
    <PlausibleProvider
      customDomain="https://insights.wsky.dev"
      trackOutboundLinks
      domain="rr-sponsorenlauf.de"
    >
      {children}
      <ToastContainer />
    </PlausibleProvider>
  </SWRConfig>
);

export default Providers;
